
import { fetchData } from './fetch';
import API from './api';
import { IResponse } from '../interface/response';
import { IRelatedAccountList } from '../interface/relatedAccount';

// 文档
// http://wiki.umucdn.cn/pages/viewpage.action?pageId=6685697

/**
* 注销
* @param  {number} size
*/
export function logOut() {
    return fetchData(API.LOGOUT.url, API.LOGOUT.type, {});
}

/**
* 获取登录过的账户列表（不包含当前用户）
* @param  {number} size
*/
export function getLoginedList(count?: number): Promise<IResponse<IRelatedAccountList>> {
    const data = {} as any;
    if (typeof count !== 'undefined') {
        data.count = count;
    }
    return fetchData(API.GET_LOGIN_ACCOUNTS.url, API.GET_LOGIN_ACCOUNTS.type, data)
        .then((res: IResponse<IRelatedAccountList>) => {
            return res ;
        });
}

/**
 * 切换账户
 * @param  {string} userToken 授权token
 */
export function switchAccount(userToken: string) {
    const data = {
        user_token: userToken,
    };

    return fetchData(API.SWITCH_ACCOUNT.url, API.SWITCH_ACCOUNT.type, data);
}

/**
 * 切换账户列表中删除
 * @param  {string} userToken 授权token
 */
export function deleteSwitchedAccount(userToken: string) {
    const data = {
        user_token: userToken,
    };
    return fetchData(API.DELETE_ACCOUNT.url, API.DELETE_ACCOUNT.type, data);
}
